module.exports = __webpack_public_path__ + "img/Alaska.3f2a2f1b.png";